import moment from "moment";
import React, { createRef, useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { Chart } from "react-google-charts";

import { assessmentGenderReport, assessmentList, assessmentProgramReport, assessmentStatusReport, overviewData } from "../../../shared/settings/apiConfig";
import { getApi, postApi } from "../../../shared/services/apiHelper";

import './Home.scss';
import '../../../shared/scss/theme.scss';


export const AssessorDashboard = (props) => {
    const [search, setsearch] = useState("")

    const customDate = (dataValue) => {
        if (dataValue) {
            let date = moment.utc(dataValue).local();
            return `${date.format('DD/MM/YYYY')}`;
        } else
            return '- - -';
    };

    const customStatus = (status) => {
        return !status?.isdeleted ? "Active" : "Inactive"
    }

    const editAction = (id) => {
        props.history.push(`/assessments/edit/${id}`);
    }

    const [config, setConfig] = useState({
        name: 'assessment',
        url: assessmentList,
        columns: [
            // { name: '', property: '', width: '50px', columnType: 'custom', customColumn: (event) => checkBox(event), customHeader: 'selectAll' },
            { name: 'ASSESSMENT NAME', property: 'assessmentname', sort: false, width: '200px' },
            { name: 'TOPIC', property: 'subtitle', sort: false, width: '200px' },
            // { name: 'ASSESSOR', property: 'subtitle', sort: false, showTooltip: true, width: '180px' },
            { name: 'CREATED DATE', property: 'createddate', sort: false, width: '100px', customColumn: customDate },
            { name: 'STATUS', property: 'isdeleted', sort: false, width: '50px', customColumn: customStatus },
            {
                name: '', property: '', columnType: 'actions', width: '50px',
                actions: {
                    header: "",
                    row: [
                        { type: 'edit', action: editAction }
                    ]
                }
            },
        ],
        field: ['id', 'assessmentname', 'subtitle', 'description', 'createddate', 'isdeleted'],
        filter: [{ field: 'isdeleted', value: 0, op: '=', 'join': 'AND' }],
        sort: [{ "field": "assessmentname", "direction": "asc" }],
        pagination: true,
    });
    const [overview, setoverview] = useState([
        {
            name: "Total Assessments",
            icon: "msg",
            count: 0,
            subname: "Currently Active",
            subcount: 0,
            color: "#f6f1ff"
        },
        {
            name: "Assessee's",
            icon: "group",
            count: 0,
            subname: "Currently Active",
            subcount: 0,
            color: "#eef9ff"
        },
        // {
        //     name: "Certified",
        //     icon: "user",
        //     count: 298,
        //     subname: "Certificate's Expired",
        //     subcount: 298,
        //     color: "#eef9ff"
        // }
    ])

    const [assessmentStatusGraphData, setAssessmentStatusGraphData] = useState([]);
    const [genderGraphData, setGenderGraphData] = useState([]);
    const [programCountGraphData, setProgramCountGraphData] = useState([]);
    const [resultStatusGraphData, setResultStatusGraphData] = useState([]);
    const [showGraph, setShowGraph] = useState(false);

    const dataTable = createRef();
    let opset = {
        title: "",
        is3D: true,
        pieStartAngle: 100,
        sliceVisibilityThreshold: 0.02,
        legend: { position: 'bottom', alignment: "end" },
        seriesType: 'bars',
        isStacked: true,

    }
    useEffect(() => {
        getApi(overviewData).then(response => {
            let resp = response?.data?.data
            setoverview([
                {
                    name: "Total Assessments",
                    icon: "msg",
                    count: resp?.totalassessments ? resp?.totalassessments : 0,
                    subname: "Currently Active",
                    subcount: resp?.activeassessments ? resp?.activeassessments : 0,
                    color: "#f6f1ff"
                },
                {
                    name: "Assessee's",
                    icon: "group",
                    count: resp?.totalassessee ? resp?.totalassessee : 0,
                    subname: "Currently Active",
                    subcount: resp?.activeassessee ? resp?.activeassessee : 0,
                    color: "#eef9ff"
                },
            ]);

            Promise.all([getAssessmentStatusReport(), getAssessmentGenderReport(), getAssessmentProgramReport()]).then(responses => {
                if (responses.length > 0) {
                    console.log(responses, "responses")
                    setAssessmentStatusGraphData(responses[0]);
                    // setResultStatusGraphData( responses[1]);
                    setGenderGraphData(responses[1]);
                    setProgramCountGraphData(responses[2]);

                    // let assessmentStatus =  [["Assessment Status","count"]]
                    // // let assessmentStatus =  [["Assessment Status",...responses[0]?.labels],["count",...responses[0]?.series]]
                    // let assessmentResultStatus = responses[1];
                    // let assessmentProgram =[["Assessment Status","count"]]
                    // let assessmentGender = responses[1]?.series.length > 0 ? [["",...responses[1]?.labels],["Assessee Gender",...responses[1]?.series]]:[]
                    // responses[2]?.labels?.map((d,i)=>{
                    //     assessmentProgram.push([d, responses[2]?.series[i]])
                    // })
                    // responses[0]?.labels?.map((d,i)=>{
                    //     assessmentStatus.push([d, responses[0]?.series[i]])
                    // })

                    // setAssessmentStatusGraphData(getAssessmentStatusPieChartData(props, assessmentStatus.series, assessmentStatus.labels, ['#15ABFF', '#6D31ED', '#FB54A4']));
                    // setResultStatusGraphData(getPieChartData(props, [1, 2, 3], ['Pass', 'Failed', 'Retake'], ['#62CD14', '#A7F172', '#CCF7AE']));
                    // setGenderGraphData(getGenderBarchartData(assessmentGender?.series, assessmentGender.labels, ["#6a9dd9", "#f5b7d1"]));

                    // setAssessmentStatusGraphData(assessmentStatus)
                    // setGenderGraphData(assessmentGender)
                    // setProgramCountGraphData(assessmentProgram)

                    setTimeout(() => {
                        setShowGraph(true);
                    }, 500);

                }
            })

        }).catch((error) => {
            console.log(error);
        });
    }, []);

    const getAssessmentStatusReport = () => {
        let payload = { filter: [] };
        return new Promise((resolve, reject) => {
            postApi(assessmentStatusReport, payload).then(response => {
                resolve(response.data.data);
            }).catch((error) => {
                reject(error);
            });
        })
    }

    const getAssessmentGenderReport = () => {
        let payload = { filter: [] };
        return new Promise((resolve, reject) => {
            postApi(assessmentGenderReport, payload).then(response => {
                resolve(response.data.data);
            }).catch((error) => {
                reject(error);
            });
        })
    }

    const getAssessmentProgramReport = () => {
        let payload = { filter: [] };
        return new Promise((resolve, reject) => {
            postApi(assessmentProgramReport, payload).then(response => {
                resolve(response.data.data);
            }).catch((error) => {
                reject(error);
            });
        })
    }

    /* custom checbox */
    const checkBox = (value) => {
        return (
            <div>
                <Form>
                    <Form.Check className="d-flex align-items-center justify-content-center" type="checkbox" label="" value={value?.id} />
                </Form>
            </div>
        );
    }

    return (
        <div className="home-container">
            <text className='screen-head'>Dashboard</text>
            <div className='d-flex align-items-center  px-3 justify-content-between w-100'>
                <div className='   w-50 d-flex align-items-center  '>
                    <img style={{ width: '1.5rem' }} src={`${process.env.PUBLIC_URL}/static/images/dashboard.png`} alt={"dashboard"} />
                    <text className='screen-sub-head my-1'>Overview</text>
                </div>
                <div className='d-flex justify-content-end align-items-center w-80 gap-2 '>
                    <div role={"button"} className="link text-primary border-primary" onClick={() => { props.history.push('/assessments/create', { title: "craft from scratch" }) }}>Create Assessment</div>
                    <div role={"button"} className="link text-primary border-primary" onClick={() => { props.history.push('/settings/users', { userAdd: true }) }}>Add User</div>
                </div>
            </div>
                <div className="d-flex gap-3 px-3 py-2">
                    {
                        overview.map((item, index) => (
                            <div key={'dashboard-card-' + index} className="p-4 shadow w-100" style={{ backgroundColor: item.color, borderRadius: "0.3rem", flex: '1 0' }}>
                                <div className="d-flex">
                                    <div style={{ flex: "1 0" }}>
                                        <text className="font-weight-bold text-l">{item.name}</text>
                                        <div className='dashboard-count'>{item.count}</div>
                                    </div>
                                    <div>
                                        <div className="border rounded border-skyblue p-2">
                                            <img style={{ width: '1.5rem' }} src={`${process.env.PUBLIC_URL}/static/images/${item.icon}.png`} alt={item?.name} />
                                        </div>
                                    </div>
                                </div>
                                {
                                    item.type == "rateBase" ? null :
                                        item.subname ?
                                            <div className="d-flex gap-1 text-s">
                                                <div style={{ fontWeight: "bolder" }}>{`${item.subname}:`} </div>
                                                <div style={{ fontWeight: "bolder" }} className="text-primary">{item.subcount} </div>
                                            </div> : null
                                }
                            </div>
                        ))
                    }
                </div>
                <div className="d-flex   w-100 align-items-center  py-3">
                    <div className='   w-50 d-flex align-items-center  '>
                        <img className={"ms-2"} style={{ width: "2.5rem", height: "2.5rem" }} src={`${process.env.PUBLIC_URL}/static/images/document.png`} alt={"document"} />
                        <text className='screen-sub-head my-1'>Detailed report</text>
                    </div>
                </div>
                {/* <div className='d-flex w-80 justify-content-end align-items-center'>
                    <button style={{ backgroundColor: "white" }} className=" d-flex align-items-center border border-1 search py-1 rounded mx-1">
                        <img style={{ maxWidth: "30px" }} className={"mx-2 w-5 h-5"} src={`${process.env.PUBLIC_URL}/static/images/import.png`} alt={"import"} />
                        <text className="text-primary text-s">Import</text>
                    </button>
                    <button style={{ backgroundColor: "white" }} className="d-flex align-items-center border border-1 search py-1 rounded mx-1">
                        <img style={{ maxWidth: "30px" }} className={"mx-2 w-5 h-5"} src={`${process.env.PUBLIC_URL}/static/images/export.png`} alt={"export"} />
                        <text className="text-primary  text-s" Export</text>
                    </button>
                </div> */}
                {/* </div> */}
                {/* <div style={{ padding: '15px' }}>
                <Datatable ref={dataTable} config={config} />
            </div> */}

                <div className="chart mb-5">
                    {
                        showGraph ?
                            <>
                                <div className="d-flex justify-content-evenly w-100 ">
                                    {genderGraphData.length > 1 ? <div className="w-30 shadow-lg p-3">
                                        <Chart
                                            chartType="Bar"
                                            data={genderGraphData}
                                            options={{ ...opset, colors: ["#f5b7d1", "#6a9dd9"], isStacked: false }}
                                            width={"100%"}
                                            height={"400px"}
                                        />
                                    </div> : null}
                                    {assessmentStatusGraphData.length > 1 ? <div className="w-30 shadow-lg p-3">
                                        <Chart
                                            chartType="PieChart"
                                            data={assessmentStatusGraphData}
                                            options={{ ...opset, colors: ["#f28400", "#528a3f", "#1d9aa5"], isStacked: true, is3D: false, title: "Assessments Status" }}
                                            width={"100%"}
                                            height={"400px"}
                                            chartEvents={[{
                                                eventName: "select",
                                                callback({ chartWrapper, eventArgs }) {
                                                    let data = chartWrapper.getChart().getSelection() || []
                                                    if (data.length > 0)
                                                        props.history.push(`/reports/assessments/${assessmentStatusGraphData[data[0]?.["row"] + 1][0].toLowerCase()}`)

                                                }
                                            }]}
                                        />

                                    </div> : null}

                                    {programCountGraphData.length > 1 ? <div className="w-30 shadow-lg p-3">
                                        <Chart
                                            chartType="PieChart"
                                            data={programCountGraphData}
                                            options={{ ...opset, isStacked: false, title: "By Program" }}
                                            width={"100%"}
                                            height={"400px"}

                                        />
                                    </div> : null}
                                    {/* <Chart options={assessmentStatusGraphData.options} series={assessmentStatusGraphData.series} type="pie" className="pie-chart-resp" /> */}
                                    {/* { resultStatusGraphData.series.length > 0 ? <Chart options={resultStatusGraphData.options} series={resultStatusGraphData.series} type="pie" className="pie-chart-resp" /> : '' } */}
                                </div>
                                {/* <div className="d-flex gap-2 w-100  my-5" >

                                    <Chart options={genderGraphData.options} series={genderGraphData.series} type="bar" className="bar-chart-resp" />
                                    <Chart options={programCountGraphData.options} series={programCountGraphData.series} type="bar" className="bar-chart-resp2" />

                                </div> */}
                            </> : null
                    }
                </div>

        </div>
    );
}